module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Le French Oven")]), _c('div', {
    staticClass: "toc"
  }, [_c('p', [_c('b', [_vm._v("Table of Contents")])]), _c('dl', [_c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01"
    }
  }, [_vm._v("Introduction ")])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02"
    }
  }, [_vm._v("French Oven Brands ")])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch03"
    }
  }, [_vm._v("How To Choose Your French Oven ")])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04"
    }
  }, [_vm._v("How To Care For Your French Oven ")])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using This Cookbook ")])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appetizers in Mini Cocottes ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e357",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetable and Feta Cheese Pot Pies ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e433",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crustless Smoked Salmon and Zucchini Quiche ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e495",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fondue Mac ’n’ Cheese ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e563",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warm Scallop Mousse with Roasted Cherry Tomatoes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e625",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer Garden Crudités with Lyonnaise Herb Dip ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e702",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marinated Goat Cheese with Roasted Garlic ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e764",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp Cocktail with Spicy Dipping Sauce ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e830",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mini Antipasto ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e886",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warm Mushroom Custards with Garlic Bread ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soups")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e980",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gorgeous Chilled Beet Soup with Beet Greens Salad ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#wsoup",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Soup with Pomegranate Seeds and Pistachios ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Artichoke Parmesan Soup ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("French Carrot Rice Soup with Homemade Croutons ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cream of Red Cabbage, Tomato, and Beef Marrow Bone Soup ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Radish Leaf, Potato, and Leeks Soup with Shredded Radish Salad ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1360",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fireside Duck and Cabbage Soup ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1439",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alsatian Beer and Munster Soup ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1506",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Velvety Pumpkin Pie Soup ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1556",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red Clam Soup with Saltine Crumb Garnish ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1610",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("French Green Lentil and Toasted Walnuts Soup ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baking ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#bgbread",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homemade Basil Garlic Bread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1773",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date and Raisin Soda Bread ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1843",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Super Creamy Goat Cheese Vegetable Lasagna ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e1944",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lamb Hachis Parmentier ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Pizza For Two ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cauliflower and Very Artichoke Gratin ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red Pepper, Potato, and Tomato Casserole ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stovetop ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Super Moist Olive Oil-Poached Salmon and Meyer Lemons ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thick Alsatian Pork Chops with Gingersnap Gravy ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2403",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mushroom and Fresh Herbes de Provence Risotto ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2471",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One-Pot Niçoise Pasta ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2537",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soft Parmesan Polenta with Arugula Salad and Poached Egg ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2625",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Breasts Stuffed with Ham, Mushrooms, and Cheese ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2697",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basque-Style Paella ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#d0e2779",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole Stuffed and Poached Chicken with Apples and Cider Sauce ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasting ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e2930",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simply Delicious Roasted Vegetables ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e3004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Roasted Steak au Poivre ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e3074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Elegant Standing Beef Rib Roast ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e3142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roast Turkey Breast with Provençal Vegetables ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e3220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Chicken à la Diable with Mustard Sauce ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#d0e3307",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Hands Praying Rack of Lamb Roast ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Braising ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e3396",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Braised Leeks and Swiss Chard with Feta and Raisins ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e3462",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fork-Tender Wine-Braised Short Ribs ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e3552",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer-Braised Beef Brisket ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e3622",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Braised Cod with Potatoes and Onions ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e3704",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon-Braised Chicken with Green Olives ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e3782",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Country-Style Pork and Beef with Lentils and Vegetables ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#d0e3874",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Braised Lamb Shanks Ossobuco with Gremolata ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stewing ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e3976",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef Stew à la Bordelaise, Caramelized Carrots, and Turned Potatoes ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e4062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Sunday Cassoulet ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e4128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mussels, Shrimp, Scallops, and White Fish Dieppoise ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e4216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poached Halibut Pot-au-Feu ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e4286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken in Riesling with Grapes and Mushrooms ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e4364",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basque Fish Stew ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#d0e4437",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef Pot-au-Feu, Deconstructed ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frying ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e4556",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nun’s Sighs ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e4625",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Potato Chips ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e4662",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crispy Fried Shrimp ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#d0e4725",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leftover Mashed Potato Croquettes ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Desserts in Mini Cocottes ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e4804",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla Pudding and Raspberry Tarts ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e4891",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butterscotch Pots de Crème ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e4943",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Individual Chocolate Fondue ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e5014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Lovers’ Panna Cotta with Lemon Curd ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e5087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Rice Pudding ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e5140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No-Machine-Needed Chocolate Ice Cream ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e5179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christmas Eve White Chocolate Mousse with Macadamia Nut Brittle ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e5257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Orange Crème Caramel ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e5315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raspberry Clafoutis with Funneled Warm Ice Cream ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#d0e5383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla Cheesecakes with Fresh Strawberry Compote ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Desserts in French Ovens ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e5451",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warm Apple Almond Crumble with Salted Butterscotch Sauce ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e5551",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warm Chocolate Semolina Spoon Cake ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e5617",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poached Pears, Rosemary Chocolate Sauce, Blue Cheese Wedge ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e5700",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot Brandied Peaches Over Ice Cream ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#d0e5758",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Cherry Soup with Sugar Cookies ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jamming ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e5866",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luscious Green Tomato and Lavender Jam ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e5914",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Strawberry Jam ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#d0e5954",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig and Port Chutney with Crumbly Aged Cheddar ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drinks For A Crowd ")])])]), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17#d0e6017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Do-It-Yourself Hot Chocolate Bar ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17#d0e6090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiday Party Mulled Wine ")])])]), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17#d0e6155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snowstorm Hot Rum Punch ")])])])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments ")])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources ")])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author ")])])]), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metric Conversion Chart")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-425e16fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bk01toc.vue
// module id = 63
// module chunks = 0